import { isIOS, isMobile } from 'react-device-detect';

export default function setVhVw(size?: any): void {
    if (!size) {
        return;
    }

    const [vh, vw] = (() => {
        if (isIOS || !isMobile) {
            return [size.innerHeight, size.innerWidth];
        }
        return [
            Math.min(size.innerHeight, size.outerHeight),
            Math.min(size.innerWidth, size.outerWidth),
        ];
    })();

    document.documentElement.style.setProperty('--vh', `${vh * 0.01}px`);
    document.documentElement.style.setProperty('--vw', `${vw * 0.01}px`);
}
